var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['body-composition body-thermal-wrapper', _vm.$i18n.locale]},[_c('div',{staticClass:"report-contrast"},[_c('div',{staticClass:"contrast-title"},[_c('span',[_vm._v(_vm._s(_vm.$t('mass.contrast')))]),_c('date-select',{attrs:{"type":1,"isCreateTime":_vm.isCreateTime},on:{"girthContras":_vm.onGetMass}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }